import { CarSchemaProps } from '@/components/molecules/CarSchema/CarSchema';

export const buildCarSchemaData = (carSchema: CarSchemaProps | null) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Car',
    name: carSchema?.name,
    brand: carSchema?.brand,
    model: carSchema?.model,
    vehicleModelDate: carSchema?.vehicleModelDate,
    image: carSchema?.image,
    bodyType: carSchema?.bodyType,
    fuelType: carSchema?.fuelType,
    numberOfDoors: carSchema?.numberOfDoors,
    seatingCapacity: carSchema?.seatingCapacity,
    vehicleEngine: {
      '@type': 'EngineSpecification',
      ...(carSchema?.torque && {
        torque: { '@type': 'QuantitativeValue', value: carSchema?.torque },
      }),
      ...(carSchema?.enginePower && {
        enginePower: {
          '@type': 'QuantitativeValue',
          value: carSchema?.enginePower,
        },
      }),
    },
    vehicleConfiguration: carSchema?.vehicleConfiguration,
    vehicleTransmission: carSchema?.vehicleTransmission,
  };
};
